<script setup lang="ts">
interface Props {
    description: string;
    notes: string;
}

defineProps<Props>();
</script>

<template>
    <div class="bg-white border p-8 rounded-lg shadow-sm font-inter sm:col-span-1">
        <div class="flex items-center gap-3">
            <span class="material-symbols-outlined text-secondary">handshake</span>
            <h1 class="font-semibold">{{ description }}</h1>
        </div>
        <p class="mt-6 text-content leading-7">{{ notes }}</p>
    </div>
</template>
